package com.ervasstudio.tracoemovimento.pages.projecto

import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.runtime.setValue
import com.ervasstudio.tracoemovimento.components.sections.Header
import com.ervasstudio.tracoemovimento.model.PopupState
import com.ervasstudio.tracoemovimento.repository.BlogRepository.checkNewsEmailExists

import com.ervasstudio.tracoemovimento.repository.BlogRepository.sendRecoveryData
import com.ervasstudio.tracoemovimento.util.rememberIsMobile
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxHeight
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.layout.Layout
import kotlinx.coroutines.launch
import org.jetbrains.compose.web.css.vw

@Page
@Layout(".components.layouts.PageLayout")
@Composable
fun ProjectoPage() {
    Column(
        modifier = Modifier
            //.width(100.vw)
            .fillMaxWidth()
            .fillMaxHeight(),
        verticalArrangement = Arrangement.Top,
        horizontalAlignment = Alignment.CenterHorizontally
    ) {
        val coroutineScope = rememberCoroutineScope()
        var popupState by remember { mutableStateOf(PopupState.FORM) }
        var apiErrorMessage by remember { mutableStateOf<String?>(null) }
        var showPopup by remember { mutableStateOf(false) }
        val isMobile = rememberIsMobile()

        Header(expandedItem = 1, isMobile = isMobile,)
        MainSectionProjecto(
            onSave = { user ->
                coroutineScope.launch {

                    apiErrorMessage = null
                    popupState = PopupState.LOADING
                    val emailExists = checkNewsEmailExists(user.email)


                    if (emailExists) {
                        apiErrorMessage = "Este e-mail já se encontra cadastrado no curso."
                        popupState = PopupState.FORM // Retorna ao formulário para o usuário corrigir
                    } else {
                        // Passo 2: Se não existe, envia o POST com os dados completos
                        val sucesso = sendRecoveryData(user)
                        if (sucesso) {
                            popupState = PopupState.SUCCESS
                        } else {
                            apiErrorMessage = "Erro de conexão ao salvar os dados. Tente novamente."
                            popupState = PopupState.FORM
                        }
                    }
                }

            },
            currentState = popupState,
            apiErrorMessage = apiErrorMessage,
            showPopup = showPopup,
            changeShowPopUp = { showPopup = it },
            changeApiErrorMessage = { apiErrorMessage = it },
            isMobile = isMobile
        )

    }

}